// no conflict
var $ = jQuery.noConflict();

$(document).ready(function () {
  $(".js-mobile-menu-open").click(function () {
    $(this).toggleClass("is-active");
    $("html, body").toggleClass("overflow-h");
    $("html, body").toggleClass("menu-open");
    $(".mobile-menu").toggleClass("is-active");

    $(".mobile-menu__sub-pages").removeClass("is-active");

    return false;
  });

  $(".mobile-menu .mobile-menu__item--children > a").click(function () {
    if ($(this).parent().hasClass("is-active")) {
      return true;
    }

    $(this).parent().toggleClass("is-active");

    return false;
  });

  // Mobile sub-menu controls
  $(".js-mobile-sub-menu-open").on("click", function (e) {
    e.preventDefault();
    $(this).closest("div").find(".mobile-menu__sub-pages").addClass("is-active");
  });

  $(".js-mobile-sub-menu-close").on("click", function (e) {
    e.preventDefault();
    $(this).closest(".mobile-menu__sub-pages").removeClass("is-active");
  });
});
